module.exports = __webpack_public_path__ + "static/media/rock.dc7cca99.svg";